import { useTranslation } from "react-i18next";
import clsx from "clsx";
import type { PlanArchivedBadgeProps } from "./types";

export const PlanArchivedBadge = ({ className }: PlanArchivedBadgeProps) => {
  const { t } = useTranslation();

  return (
    <span
      className={clsx(
        "flex-shrink-0 rounded bg-amber-100 px-1.5 py-0.5 text-xs font-medium text-amber-700",
        className,
      )}
    >
      {t("smartSurveyor.planFilter.archived")}
    </span>
  );
};
